import { useState } from 'react';
import SearchField from 'src/shared/components/form/searchField';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import { ContactUnsubscriptionList } from '../components/contactUnsubscriptionList';

export const GroupMessageSmsUnsubscribedPage = () => {
  const [searchString, setSearchString] = useState<string | undefined>(undefined);

  return (
    <>
      <PageFilterSection leftContent={<SearchField initialValue='' onSearch={(newSearch) => setSearchString(newSearch || undefined)} />} />
      <ContactUnsubscriptionList searchString={searchString} type='sms' />
    </>
  );
};
